import { useLayoutEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Banner as BannerData } from '@api/banner';
import {
  BannerContainer,
  BannerBadge,
  BannerTitle,
  BannerButton,
  BannerDescription,
  BannerCloseButton,
} from './BannerStyles';
interface BannerProps {
  banner: BannerData;
  onClose: () => void;
  isClosing?: boolean;
}

const useIsClamped = (dependency: string) => {
  const ref = useRef<HTMLElement>(null);
  const [isClamped, setIsClamped] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    setIsClamped(el.scrollHeight > el.clientHeight + 1);
  }, [dependency]);

  return { ref, isClamped };
};

const Banner = ({ banner, onClose, isClosing = false }: BannerProps) => {
  const title = useIsClamped(banner.title);
  const description = useIsClamped(banner.description);

  return (
    <BannerContainer isClosing={isClosing}>
      <BannerCloseButton aria-label="Close banner" onClick={onClose}>
        <CloseIcon sx={{ fontSize: '1rem' }} />
      </BannerCloseButton>

      {banner?.label?.trim() && <BannerBadge>{banner.label}</BannerBadge>}
      <Tooltip title={title.isClamped ? banner.title : ''} placement="top">
        <BannerTitle ref={title.ref}>{banner.title}</BannerTitle>
      </Tooltip>
      <Tooltip title={description.isClamped ? banner.description : ''} placement="top">
        <BannerDescription ref={description.ref}>{banner.description}</BannerDescription>
      </Tooltip>
      <BannerButton onClick={() => window.open(banner.ctaUrl, '_blank', 'noopener,noreferrer')}>
        {banner.cta}
      </BannerButton>
    </BannerContainer>
  );
};
export default Banner;
